import { useState, memo } from 'react'

import { GuiddeLoad, SpacedGroup } from 'UI/Components'

import { MenuItem, Select, Button, TextField, Box } from '@material-ui/core'

export const NewDictionary = memo(
    ({ isLoading, dictionariesTypes, createPhrase, languageOptions }) => {
        const [description, setDescription] = useState(null)
        const [phrase, setPhrase] = useState('')
        const [language, setLanguage] = useState(languageOptions[0])

        const add = () => {
            createPhrase({
                description,
                phrase: phrase,
                source: 'admin',
                lang: language.value.substring(0, 2)
            }).then(() => {
                setDescription(null)
                setPhrase('')
            })
        }

        if (isLoading) return <GuiddeLoad />

        return (
            <Box mt={2}>
                <SpacedGroup style={{ alignItems: 'flex-end' }}>
                    <TextField
                        label="Add phrase"
                        placeholder="Enter phrase"
                        value={phrase}
                        onChange={e => setPhrase(e.target.value.trim())}
                    />
                    <Select
                        value={description || ''}
                        onChange={({ target }) => setDescription(target.value)}
                        displayEmpty
                        style={{ minWidth: '130px' }}
                    >
                        <MenuItem value="">
                            <em>None</em>
                        </MenuItem>
                        {dictionariesTypes.map((type, i) => (
                            <MenuItem key={i} value={type.value}>
                                {type.name}
                            </MenuItem>
                        ))}
                    </Select>

                    <Select
                        value={language.value}
                        defaultValue={languageOptions[0]}
                        onChange={({ target }) => setLanguage(target)}
                        style={{ minWidth: '150px' }}
                    >
                        {languageOptions.map((lang, i) => (
                            <MenuItem key={i} value={lang.value}>
                                {lang.name}
                            </MenuItem>
                        ))}
                    </Select>
                    <Button onClick={add} disabled={!description || !phrase}>
                        Add
                    </Button>
                </SpacedGroup>
            </Box>
        )
    }
)
